import { Party } from "../enums/Party";
import { FormikStepper } from "../navigation/FormikStepper";
import { FormikStep } from "../navigation/FormikStep";
import { PhysicianPages } from "../enums/PhysicianPages";
import PhysicianStart from "../page/physician/PhysicianStart";
import { object } from "yup";
import {
    dateRangeValidator,
    validateDocumentContent,
    validateDocumentsTotalSize
} from "../../form/Validators";
import AboutPhysician from "../page/physician/AboutPhysician";
import AboutRelationship from "../page/common/AboutRelationship";
import PhysicianClaimType from "../page/physician/PhysicianClaimType";
import CoveredIndividual from "../page/physician/CoveredIndividual";
import Condition from "../page/physician/Condition";
import PatientCare from "../page/physician/PatientCare";
import PhysicianEmployment from "../page/physician/PhysicianEmployment";
import PhysicianSummary from "../page/physician/PhysicianSummary";
import React from "react";
import { gatherInitialValues, submitHandler } from "../../service/FormService";
import { BenefitType } from "../enums/BenefitType";
import PhysicianDocument from "../page/physician/PhysicianDocument";
import PhysicianFinished from "../page/physician/PhysicianFinished";
import { Relationship } from "../enums/Relationship";
import { useParams } from "react-router-dom";
import { FormikValues } from "formik";

const Physician = () => {
    const params = useParams();
    const coverage = params.coverage as BenefitType;
    const claimId = params.claimId;

    const initialValues = gatherInitialValues(claimId, coverage, Party.PHYSICIAN) as FormikValues;

    return <FormikStepper initialValues={initialValues}
                          onSubmit={submitHandler}>
        <FormikStep label={PhysicianPages.START}>
            <PhysicianStart/>
        </FormikStep>
        <FormikStep label={PhysicianPages.PHYSICIAN_INFO} hideStep={(initialValues) => initialValues.physicianFirstName === undefined}>
            <AboutPhysician/>
        </FormikStep>
        <FormikStep label={PhysicianPages.PATIENT_INFO} hideStep={(initialValues) => initialValues.relationship === undefined}>
            <AboutRelationship/>
        </FormikStep>
        <FormikStep label={PhysicianPages.CLAIM_TYPE} hideStep={(initialValues) =>
            initialValues.leaveType === undefined
            && initialValues.conditionType === undefined}>
            <PhysicianClaimType/>
        </FormikStep>
        <FormikStep label={PhysicianPages.CONDITION} hideStep={(initialValues) => initialValues.diagnoses === undefined}
                    validate={(values) => {
                        if ([values.inpatientCare, values.permanentOrLongTermCondition, values.multipleTreatmentsAndRecovery,
                            values.chronic, values.pregnancy, values.incapacityAndTreatment]
                            .every(item => item === false)) {
                            return {
                                inpatientCare: 'Please specify at least one serious health condition type.'
                            }
                        }
                    }}>
            <Condition/>
        </FormikStep>
        <FormikStep label={PhysicianPages.COVERED_INDIVIDUAL}
                    hideStep={(initialValues, values) => initialValues.patientRelationship === undefined || values.relationship === Relationship.EMPLOYEE }>
            <CoveredIndividual/>
        </FormikStep>
        <FormikStep label={PhysicianPages.ABILITY_TO_WORK}
                    hideStep={(initialValues, values) => initialValues.returnToWork === undefined
                        || Relationship.FAMILY_MEMBER === values?.relationship}>
            <PhysicianEmployment/>
        </FormikStep>
        <FormikStep label={PhysicianPages.PATIENT_CARE} hideStep={(initialValues) => initialValues.conditionStartDate === undefined}
                    validationSchema={object({
                        restrictionOrCareStartDate: dateRangeValidator('conditionStartDate'),
                        restrictionOrCareEndDate: dateRangeValidator('restrictionOrCareStartDate'),
                    })} validate={(values) => {
            if (values.medications && [values.medications, values.surgeries, values.therapies, values.referrals]
                .every(item => item.length === 0)) {
                return {
                    medications: 'Please specify at least one treatment.'
                }
            }
        }}>
            <PatientCare/>
        </FormikStep>
        <FormikStep label={PhysicianPages.DOCUMENT} hideStep={(initialValues) => initialValues.documents === undefined} validationSchema={object({
            documents: validateDocumentContent()
        })} validate={(values) => validateDocumentsTotalSize(values)}>
            <PhysicianDocument/>
        </FormikStep>
        <FormikStep label={PhysicianPages.SUMMARY}>
            <PhysicianSummary/>
        </FormikStep>
        <FormikStep label={PhysicianPages.FINISH}>
            <PhysicianFinished/>
        </FormikStep>
    </FormikStepper>
}

export default Physician;
